module.exports = __webpack_public_path__ + "static/media/socker-min.241e3652.png";